import React from "react";
import BackdropPopup from "../BackdropPopup/BackdropPopup";
import closeIcon from '../../../assests/close-white.png'
import classes from './DynamicPopup.module.css'

const DynamicPopup = ({ title, icon, closePopup, dropClass, children, myHeight, myWidth, minHeight }) => {

    return (
        <BackdropPopup myHeight={myHeight} myWidth={myWidth} minHeight={minHeight}>
            <div className={dropClass}>
                <div className={classes.Header}>
                    <img className={classes.Close} onClick={closePopup} src={closeIcon} alt="closeIcon" />
                    {icon && <img className={classes.Icon} src={icon} alt="icon" />}
                    <p>{title}</p>
                </div>
                {children}
            </div>
        </BackdropPopup>
    )
}

export default DynamicPopup;